import { t } from 'i18n'
import React from 'react'
import moment from 'moment'

const valueOrDash = (value) => {
  return value || <>&mdash;</>
}

const scope = 'components.inheritance_check.table'

const Item = ({ name, value }) => {
  return (
    <dl className='row'>
      <dt className="col-sm-12 col-lg-5">{t(name, { scope })}</dt>
      <dd className="col-sm-12 col-lg-7">{valueOrDash(value)}</dd>
    </dl>
  )
}

const InheritanceMatterShow = ({ inheritanceCheck }) => {
  return (
    <>
      <div className='inheritance-show-header'>
        <a href='/inheritance_checks' className='back-link'>
          <i className='fa fa-chevron-left me-2' aria-hidden='true' />
          {t('components.inheritance_check.go_to_history')}
        </a>
        <a
          className='btn btn-primary btn-lg download-pdf'
          href={`/inheritance_checks/${inheritanceCheck.id}/view_document?format=pdf`}
          target="_blank"
        >
          <i className='fa fa-download me-2' />
          {t('components.inheritance_check.download_pdf')}
        </a>
      </div>
      <h1 className='page-title text-center'>{t('components.inheritance_check.inheritance_register')}</h1>
      <p>
        {`${t('request_data', { scope })}: `}
        {inheritanceCheck.searcherName}, {moment(inheritanceCheck.createdAt).format(t('moment_time.formats.default'))}
      </p>
      {inheritanceCheck.inheritanceMatters.map(matter =>
        <div key={`matter-${matter.id}`}>
          <h2 className='section-title'>
            {t('inheritance_check', { scope })} {t('number', { scope })} {matter.matterNo}
          </h2>
          <div className='inheritance-table-container'>
            <table className='table inheritance-checks-table services-table bg-light-blue mb-5'>
              <tbody>
                <tr className='bg-light-blue'>
                  <th>{t('inheritance_check', { scope })}</th>
                  <td>
                    <div className="row">
                      <div className="col-xs-12 col-md-6">
                        <Item name='notary' value={`${matter.notaryName}, ${matter.notaryAddress}`}/>
                        <Item name='registration_number' value={matter.matterNo} />
                        <Item name='registration_date' value={moment(matter.registered).format(t('moment_time.formats.default'))} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t('testators', { scope })}</th>
                  <td>
                    {matter.testators.map((testator) =>
                    <div className="testator-row-container" key={`testator-${testator.id}`}>
                      <div className="row">
                        <div className="col-xs-12 col-md-6">
                          <Item name='personal_code' value={testator.formattedPersonId} />
                          <Item name='name' value={testator.firstName} />
                          <Item name='last_name' value={testator.surname} />
                          <Item name='birth_date' value={testator.birthDate} />
                          <Item name='death_date' value={testator.deathDate} />
                        </div>
                        <div className="col-xs-12 col-md-6">
                          <Item name='alt_name' value={testator.altFirstName} />
                          <Item name='alt_last_name' value={testator.altSurname} />
                          <Item name='other_names' value={testator.otherNames} />
                        </div>
                      </div>
                    </div>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>{t('proclamation', { scope })}</th>
                  <td>
                    <div className="row">
                      <div className="col-xs-12 col-md-6">
                        <Item name='announced' value={matter.announceType} />
                        <Item name='issue_number' value={matter.issue} />
                        <Item name='announcement_date' value={matter.announced} />
                        <Item name='application_deadline' value={matter.invitationTerm == 0 ? <>&mdash;</> : matter.invitationTerm} />
                        <Item name='announcement' value={matter.annoucement} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t('notes', { scope })}</th>
                  <td>
                    <div className="row">
                      <div className="col-xs-12 col-md-6">
                        <dl className='row'>
                          <dd className="col-lg-12 mb-0">{valueOrDash(matter.notes)}</dd>
                        </dl>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        )}
    </>
  )
}

export default InheritanceMatterShow
